import request from "@/api/request";

export function fetchHomeData() {
  return request.get("/official/home");
}
